module.exports = __webpack_public_path__ + "fd671a227dac5267a90665cb8fe66fd4.pdf";